import { fetchWithAuthorization } from './fetch'
import { FetchError } from '../errors/FetchError'

export const fetchNotifications = async (page = 1, limit = 10) => {
  try {
    const data = await fetchWithAuthorization(`/notifications?page=${page}&limit=${limit}`)
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to fetch Notifications failed')
  }
}

export const markNotificationsAsRead = async (id = null) => {
  try {
    const data = await fetchWithAuthorization(`/notifications/${id || 'all'}`, null, 'PUT')
    return data
  } catch (error) {
    throw new FetchError(error, 'Http call to mark notificacions as read failed')
  }
}
